import { SVGIconComponent } from './types';

export const PadLock: SVGIconComponent = ({ className, color, style }) => (
  <svg
    version="1.1"
    width="33px"
    height="47px"
    viewBox="0 0 33 47"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Projects-and-Groups" stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd" opacity="1">
      <g id="Screen/Group" transform="translate(-1149, -218)" fill="#FFFFFF">
        <g id="PadLocked" transform="translate(1149, 218)">
          <path
            d="M28.7558256,19.0319368 L27.3947745,19.0319368 L27.3947745,10.8194626 C27.3947745,4.85419815 22.5082165,0 16.5000773,0 C10.4919382,0 5.60331845,4.85389108 5.60331845,10.8194626 L5.60331845,19.0319368 L4.24226734,19.0319368 C1.89864722,19.0319368 0,20.917116 0,23.2441116 L0,42.7878247 C0,45.1148203 1.90065741,47 4.24226734,47 L28.7557225,47 C31.0993426,47 33,45.1128249 33,42.7878247 L33,23.2441116 C33,20.917116 31.0993426,19.0319368 28.7557225,19.0319368 L28.7558256,19.0319368 Z M9.41679748,10.8194626 C9.41679748,6.94117069 12.5939751,3.7866328 16.4998711,3.7866328 C20.4038601,3.7866328 23.5829448,6.94127305 23.5829448,10.8194626 L23.5829448,19.0319368 L9.41679748,19.0319368 L9.41679748,10.8194626 Z M18.6703575,32.8017898 L18.6703575,38.0613147 C18.6703575,39.2507852 17.6999011,40.2163535 16.4999227,40.2163535 C15.3019544,40.2163535 14.3294879,39.2507852 14.3294879,38.0613147 L14.3294879,32.8017898 C13.3126942,32.1120689 12.6462915,30.9545844 12.6462915,29.6391658 C12.6462915,27.5240967 14.3718049,25.8108232 16.4999742,25.8108232 C18.6281436,25.8108232 20.353657,27.5260927 20.353657,29.6391658 C20.353657,30.9545844 19.6872027,32.1120689 18.6704606,32.8017898 L18.6703575,32.8017898 Z"
            id="Fill-1"
            fill="currentColor"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
